import Helmet from 'react-helmet';

const GOOGLE_FONT_URL = 'https://fonts.googleapis.com/css2';

const fontFamilies = [
  'Inter:wght@400;700',
  'Poppins:wght@400;600;700',
  'Noto Sans KR:wght@400;700',
];

function Font() {
  const url = new URL(GOOGLE_FONT_URL);

  for (const fontFamily of fontFamilies) {
    url.searchParams.append('family', fontFamily);
  }

  url.searchParams.append('display', 'block');

  return (
    <Helmet>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link href={`${url}`} rel="stylesheet" />
    </Helmet>
  );
}

export default Font;
